module.exports = __webpack_public_path__ + "img/bad.3ed13d0.png";